import ENV from "@/constants/env";

// The "keep-alive" mechanic: a countdown starts at BASE_DAYS from GENESIS_TIMESTAMP, and every
// successful transaction to the shared Games Proxy contract (any game - token flip, blackjack,
// hide and seek, RPS, one-vs-one, roulette, raffle) since genesis adds BONUS_HOURS_PER_TRANSACTION
// more hours to the deadline. As long as the site gets transactions often enough, it never runs
// out; if activity stops for long enough to burn through the banked time, the site goes dark.
//
// Deliberately derived entirely from public on-chain transaction history (no backend, no contract
// change) - see helpers/elrondApi.ts#getTransactionsCountToProxy and store/shutdown.ts. All three
// parameters are env-configurable (see .env) rather than hardcoded.
const SHUTDOWN = {
  // The moment this experiment began, as a unix timestamp (seconds). Only change VUE_APP_SHUTDOWN_GENESIS
  // to relaunch the mechanic from scratch (transactions before it never count).
  GENESIS_TIMESTAMP: Math.floor(Date.parse(ENV.SHUTDOWN_GENESIS) / 1000),

  BASE_DAYS: ENV.SHUTDOWN_BASE_DAYS,
  BONUS_HOURS_PER_TRANSACTION: ENV.SHUTDOWN_BONUS_HOURS_PER_TX,

  DAY_SECONDS: 86400,
  HOUR_SECONDS: 3600,

  // How often to re-check on-chain activity while the app is open, in milliseconds.
  REFRESH_INTERVAL: 60_000,
};

export default SHUTDOWN;
